import {requestOptions} from "./base";

export const getLocationData = () => (
  requestOptions('campaign/location-data', {
    method: 'GET',
  })
);


export const getAllZipCodes = () => (
  requestOptions('campaign/location-zip', {
    method: 'GET',
  })
);
